import Colors from '@/theme/constants/Colors';
import { Chip, styled } from '@mui/material';

export const SmallChipStyled = styled(Chip)(({ theme }) => ({
  borderRadius: theme.spacing(0.25),
  color: Colors.COLOR_WHITE_TEXT,
  fontSize: theme.typography.caption.fontSize,
}));

export const MediumChipStyled = styled(Chip)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  color: Colors.COLOR_WHITE_TEXT,
  fontSize: '14px',
  padding: '5px 0px',
  fontWeight: 400,
  textTransform: 'capitalize',
}));
